<template>
    <v-container>
        <h1>メンテナンスページ</h1>
        <hr class="ma-5" />
        <h3>保存データ</h3>
        <v-row justify="start">
            <v-col>
                <v-btn @click='deleteUser'>Del</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>

</style>
<script>
import axios from "axios";

export default {
    data: () => ({
    }),
    created: async function () {
        if (!this.$store.getters.isMaintenance) {
            this.$router.push('/');
            return;
        }
    },
    destroyed: function () {
    },
    methods: {
        deleteUser() {
            localStorage.removeItem(this.$store.getters.shopKey + "_key");
            localStorage.removeItem(this.$store.getters.shopKey + "_data");
            location.reload();
        }
    },
    computed: {
    },
    watch: {
    }
};
</script>
